var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#36C5F0",
    d: "M5.348 11.748a1.9 1.9 0 1 1-1.9-1.9h1.9v1.9Zm0.95 0a1.9 1.9 0 1 1 3.8 0v4.75a1.9 1.9 0 1 1-3.8 0v-4.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2EB67D",
    d: "M8.197 5.348A1.9 1.9 0 1 1 10.097 3.45v1.9H8.197Zm0 0.95a1.9 1.9 0 1 1 0 3.8H3.45a1.9 1.9 0 1 1 0-3.8h4.747Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECB22E",
    d: "M14.65 8.252a1.9 1.9 0 1 1 1.9 1.9h-1.9V8.252Zm-0.95 0a1.9 1.9 0 1 1-3.8 0V3.45a1.9 1.9 0 1 1 3.8 0v4.802Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E01E5A",
    d: "M11.803 14.65a1.9 1.9 0 1 1-1.9 1.9V14.65h1.9Zm0-0.95a1.9 1.9 0 1 1 0-3.8h4.8a1.9 1.9 0 1 1 0 3.8h-4.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.389270cc2b320e35d89894d4152e70ee.svg";
export { ForwardRef as ReactComponent };